var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChangeIcon = function SvgChangeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "change_icon_on",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.5 18.5",
    xmlSpace: "preserve",
    className: "svg-inline--fa fa-change-icon",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15.813 9.5) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0.2,6.4C-0.3,6.1-0.5,5.5-0.2,5C-0.1,4.8,0,4.7,0.2,4.6l4-2.3c0.5-0.3,1.1-0.1,1.4,0.4 C5.6,2.9,5.7,3,5.7,3.2v4.6c0,0.6-0.4,1-1,1c-0.2,0-0.3,0-0.5-0.1L0.2,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.3,0c0,4.4-2.8,5.6-6.7,5.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.9,6.4C2.4,6.1,2.2,5.5,2.5,5c0.1-0.2,0.2-0.3,0.4-0.4l4-2.3c0.5-0.3,1.1-0.1,1.4,0.4 c0.1,0.2,0.1,0.3,0.1,0.5v4.5c0,0.6-0.4,1-1,1c-0.2,0-0.3,0-0.5-0.1L2.9,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15,0c0,4.4-2.8,5.6-6.7,5.8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change_icon.0a31f7d6.svg";
export { ForwardRef as ReactComponent };